import {
    lineDateSortOptions,
    LineDateSortOptionType,
    LineDateSortType,
} from '../../constants'

interface UseInviteLinksTimeSelectorsProps {
    setLineDate: (value: LineDateSortOptionType | null) => void
    setStartDate: (value: string) => void
    setEndDate: (value: string) => void
}
export const useInviteLinksTimeSelectors = ({
    setLineDate,
    setStartDate,
    setEndDate,
}: UseInviteLinksTimeSelectorsProps) => {
    const getDateRangeForLineDateOption = (
        value: LineDateSortType
    ): { startDate: string; endDate: string } => {
        const today = new Date()
        let startDate: string, endDate: string

        const getAdjustedDate = (daysToSubtract: number): Date => {
            const date = new Date(today)
            date.setDate(date.getDate() - daysToSubtract)
            return date
        }

        const formatDate = (date: Date): string =>
            date.toISOString().split('T')[0]

        switch (value) {
            case 'today':
                startDate = endDate = formatDate(today)
                break
            case 'yesterday':
                startDate = endDate = formatDate(getAdjustedDate(1))
                break
            case 'week':
                startDate = formatDate(getAdjustedDate(6))
                endDate = formatDate(today)
                break
            case 'month':
                startDate = formatDate(getAdjustedDate(29))
                endDate = formatDate(today)
                break
            case 'quarter':
                startDate = formatDate(getAdjustedDate(89))
                endDate = formatDate(today)
                break
            case 'year':
                startDate = formatDate(getAdjustedDate(364))
                endDate = formatDate(today)
                break
            default:
                startDate = ''
                endDate = ''
        }

        return { startDate, endDate }
    }

    const handleLineDateSelect = (value: LineDateSortOptionType) => {
        setLineDate(value)
        const { startDate, endDate } = getDateRangeForLineDateOption(
            value.value
        )
        setStartDate(startDate)
        setEndDate(endDate)
    }

    const handleDateChange = (startDate: string, endDate: string) => {
        setStartDate(startDate)
        setEndDate(endDate)

        const lineDateOption = getLineDateOptionForDateRange(startDate, endDate)
        setLineDate(lineDateOption)
    }

    const getLineDateOptionForDateRange = (
        startDate: string,
        endDate: string
    ): LineDateSortOptionType | null => {
        const parseDate = (dateString: string): Date => {
            return new Date(dateString)
        }
        const start = parseDate(startDate)
        const end = parseDate(endDate)
        const today = new Date()

        const getAdjustedDate = (daysToSubtract: number): Date => {
            const date = new Date(today)
            date.setDate(date.getDate() - daysToSubtract)
            return date
        }

        const formatDate = (date: Date): string => {
            return date.toISOString().split('T')[0]
        }

        const isDateMatch = (date: Date, adjustedDays: number): boolean =>
            formatDate(date) === formatDate(getAdjustedDate(adjustedDays))

        if (isDateMatch(start, 0) && isDateMatch(end, 0)) {
            return lineDateSortOptions[0]
        }

        if (isDateMatch(start, 1) && isDateMatch(end, 1)) {
            return lineDateSortOptions[1]
        }

        if (isDateMatch(start, 6) && isDateMatch(end, 0)) {
            return lineDateSortOptions[2]
        }

        if (isDateMatch(start, 29) && isDateMatch(end, 0)) {
            return lineDateSortOptions[3]
        }

        if (isDateMatch(start, 89) && isDateMatch(end, 0)) {
            return lineDateSortOptions[4]
        }

        if (isDateMatch(start, 364) && isDateMatch(end, 0)) {
            return lineDateSortOptions[5]
        }

        return null
    }

    return { handleLineDateSelect, handleDateChange }
}
